import React, { useRef, useState } from "react";
import { FiMail } from "react-icons/fi";
import { BsWhatsapp } from "react-icons/bs";
import { FaInstagram, FaGithubSquare, FaLinkedin } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { motion } from "framer-motion";

// Must stay as full `process.env.X` expressions: Create React App inlines these
// at build time by literal substitution, so destructuring would leave them undefined.
const SERVICE_ID = process.env.REACT_APP_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;

const Contact = () => {
  const container = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.3 },
    },
  };

  const childVariant = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1 },
  };

  const form = useRef();
  const [sending, setSending] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();

    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
      toast.error(
        "The contact form isn't configured. Please reach me at wasemm@live.com."
      );
      return;
    }

    setSending(true);
    try {
      // sendForm throws synchronously on bad config and rejects on network or
      // API errors, so both paths have to go through this try/catch.
      await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY);
      toast.success("Message sent successfully!");
      form.current.reset();
    } catch (error) {
      const reason =
        typeof error === "string"
          ? error
          : error?.text || error?.message || "please try again later";
      toast.error(`Failed to send the message: ${reason}`);
      // The form is intentionally left filled so the message isn't lost.
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      id="contact"
      className="w-screen flex  lg:h-screen items-center flex-col tablet:px-8 md:px-12 sm:py-10 "
    >
      <div className="Contact-header">
        <h1 className="text-4xl font-bold  ">Contact Me</h1>
        <span className="underline w-full   block  relative mt-3 h-1 bg-black mb-6">
          <span className="underline-node bg-dark-orange "></span>
        </span>
      </div>
      <div className="contact-container grid grid-cols-1  gap-y-8 lg:grid-cols-[35%_45%] gap-4 w-full  rounded-2xl justify-center  bg-primary-color w-[93%] md:w-[85%] py-10 px-6 mt-4 relative lg:pt-20  max-h-full tablet:h-[90%]">
        <div className="contact-options flex flex-col gap-4 sm:gap-8 text-white ">
          <motion.div
            className="flex flex-col gap-8"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.5 }}
            variants={{
              hidden: { opacity: 0, y: -50 },
              visible: { opacity: 1, y: 0 },
            }}
          >
            <div className="contact-option border border-white  py-4 rounded-xl flex flex-col items-center tablet:gap-2 w-full lg:w-[60%] h-[130px] tablet:h-[140px] sm:h-[150px] justify-center">
              <FiMail />
              <h4>Email</h4> <h5>wasemm@live.com</h5>{" "}
              <a
                className="text-dark-orange"
                href="mailto:wasemm@live.com"
                target="_blank"
                rel="noreferrer"
              >
                Send a message
              </a>
            </div>
            <div className="contact-option border border-white py-4 rounded-xl flex flex-col  items-center tablet:gap-2 gap-1 w-full lg:w-[60%] h-[130px] tablet:h-[140px] sm:h-[150px] justify-center">
              <BsWhatsapp />
              <h4>WhatsApp</h4>{" "}
              <a
                className="text-dark-orange"
                href="http://api.whatsapp.com/send?phone=+4915771109914"
                target="_blank"
                rel="noreferrer"
              >
                Send a message
              </a>
            </div>
          </motion.div>
          <motion.div
            className="flex justify-around w-full lg:w-[60%] text-2xl md:text-3xl text-white "
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            variants={container}
          >
            <motion.a
              className="icon"
              href="https://github.com/altinawiwaseem"
              target="_blank"
              rel="noreferrer"
              variants={childVariant}
            >
              <FaGithubSquare />
            </motion.a>
            <motion.a
              className="icon"
              href="https://www.linkedin.com/in/waseem-altinawi/"
              target="_blank"
              rel="noreferrer"
              variants={childVariant}
            >
              <FaLinkedin />
            </motion.a>
            <motion.a
              className="icon"
              href="https://www.instagram.com/waseemdam/"
              target="_blank"
              rel="noreferrer"
              variants={childVariant}
            >
              <FaInstagram />
            </motion.a>
          </motion.div>
        </div>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: 50 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <form ref={form} onSubmit={sendEmail} className="form">
            <input
              type="text"
              name="name"
              placeholder="Your Full Name"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
            />
            <textarea
              name="message"
              rows="7"
              placeholder="Your Message"
              required
            ></textarea>
            <button
              type="submit"
              className="primary-btn btn"
              disabled={sending}
            >
              {sending ? "Sending..." : "Send Message"}
            </button>
          </form>
        </motion.div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Contact;
